type Props = {
  height?: number;
  width?: number;
};

export const LChildIcon = ({ height = 9, width = 13, ...rest }: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 9 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path d="M1 0V12H9" stroke="#DADEDF" strokeWidth="2" />
    </svg>
  );
};
